
import { css } from 'lit';
export default css`
.search-result-card {
  display: flex;
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(164, 167, 171, var(--tw-border-opacity));
  padding: 36px 0 28px;
}

  .search-result-card__label-small {
  --tw-text-opacity: 1;
  color: rgba(117, 118, 119, var(--tw-text-opacity));
}

  .search-result-card__label-small {
    margin-bottom: 17px;
  }

  .search-result-card__title {
  margin-bottom: 1rem;
}

  .search-result-card__body {
    font-size: 18px;
    font-weight: 400;
    line-height: 27px;
  }

  .search-result-card__content-wrapper {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity));
}
`;